import { z } from 'zod';

const REQUIRED_REASON_MESSAGE = 'กรุณาระบุสาเหตุที่ปิดรับสมัครชั่วคราว';
const REQUIRED_REASON_MIN_LENGTH = 1;

export const TemporarilyCloseExamEventFormSchema = z.object({
  reason: z
    .string({
      message: REQUIRED_REASON_MESSAGE,
    })
    .trim()
    .min(REQUIRED_REASON_MIN_LENGTH, {
      message: REQUIRED_REASON_MESSAGE,
    }),
});

export type TemporarilyCloseExamEventFormType = z.infer<typeof TemporarilyCloseExamEventFormSchema>;
